/* ecore tech elements */
gsap.utils.toArray(".animation-fade-in").forEach(element => {
  gsap.fromTo(element, 
    {
      opacity: 0,
    },         
    {
      duration: 0.5,
      delay: 1,
      opacity: 1,
      ease: "power",
      stagger: 0.02,
      
      scrollTrigger: {
        trigger: element,
        start: "top 40%",
        end: "50% 30%",
        scrub: 0.8,
        //markers: true
      }
    });
  }
);

/* WORD ANIMATION TEST */
gsap.config({ trialWarn: false });
gsap.registerPlugin(ScrollTrigger, SplitText);
const split = new SplitText(".text p", { type: "lines" });

split.lines.forEach((target) => {
  gsap.to(target, {
    backgroundPositionX: 0,
    duration:2,
    blur: 15,
    yPercent: -50,
    ease: "circ.out",
    scrollTrigger: {
      trigger: target,
      //markers: true,
      scrub: 1.2,
      blur: 0,
      start: "top 70%",
      end: "100% 70%"
      //end: '+=50000px'
    }
  });
});


/* scroll text rolling
$(window).on('scroll', function() {
  const scrollerOffset = $('.scroller').offset().top;
  const windowHeight = $(window).height();
  const scrollTop = $(window).scrollTop();

  if (scrollTop < scrollerOffset) {
    $('.content').removeClass('scrolled1 scrolled2 scrolled3');
    return;
  }

  const scrollPercentage = (scrollTop - scrollerOffset + windowHeight) / $('.scroller').height();

  if (scrollPercentage < 0.2) {
    $('.content').removeClass('scrolled1 scrolled2 scrolled3');
  } else if (scrollPercentage >= 0.01 && scrollPercentage < 0.45) {
    $('.content').removeClass('scrolled2 scrolled3').addClass('scrolled1');
  } else if (scrollPercentage >= 0.45 && scrollPercentage < 0.7) {
    $('.content').removeClass('scrolled1 scrolled3').addClass('scrolled2');
  } else if (scrollPercentage >= 0.7 && scrollPercentage < 0.99) {
    $('.content').removeClass('scrolled1 scrolled2').addClass('scrolled3');
  } else {
    $('.content').removeClass('scrolled1 scrolled2 scrolled3');
  }
});
*/


/* VIDEO SCROLL 2 */
/* removed cause of loading
const lenis = new Lenis()

lenis.on('scroll', (e) => {
  console.log(e)
})

function raf(time) {
  lenis.raf(time)
  requestAnimationFrame(raf)
}

requestAnimationFrame(raf)
*/

/* add bottomed class */
$(document).ready(function() {
    $(window).on('scroll', function() {
        $('.innerSectionVideo').each(function() {
            var $this = $(this);
            var bottom_of_element = $this.offset().top + $this.outerHeight();
            var bottom_of_window = $(window).scrollTop() + $(window).height();

            if (bottom_of_window >= bottom_of_element) {
                $this.addClass('bottomed');
            } else {
                $this.removeClass('bottomed');
            }
        });
    });
});

/* scroll text rolling */
$(document).ready(function () {
    var $scroller = $('.innerSectionVideo');
    var $h3s = $('.rollingBox h3');
    var scrollerTop = $scroller.offset().top;
    var scrollerHeight = $scroller.height();
    var windowHeight = $(window).height();
    var highlightPoints = [
        scrollerTop + scrollerHeight * .2,
        scrollerTop + scrollerHeight * .35,
        scrollerTop + scrollerHeight * .5,
        scrollerTop + scrollerHeight * .65,
        scrollerTop + scrollerHeight * .8,
    ];

	var lastScrollTop = 0;

    $(window).on('scroll', function () {
        var scrollTop = $(window).scrollTop();
        var bottom_of_window = scrollTop + windowHeight;
        var isScrollingDown = scrollTop > lastScrollTop;
        lastScrollTop = scrollTop;

        if (bottom_of_window >= scrollerTop && scrollTop <= scrollerTop + scrollerHeight) {
            if (isScrollingDown) {
                if (bottom_of_window >= highlightPoints[0]) {$h3s.eq(0).addClass('highlight');}
                if (bottom_of_window >= highlightPoints[1]) {$h3s.eq(1).addClass('highlight');}
                if (bottom_of_window >= highlightPoints[2]) {$h3s.eq(2).addClass('highlight');}
                if (bottom_of_window >= highlightPoints[3]) {$h3s.eq(3).addClass('highlight');}
                if (bottom_of_window >= highlightPoints[4]) {$h3s.eq(4).addClass('highlight');}
                if (bottom_of_window >= highlightPoints[5]) {$h3s.eq(5).addClass('highlight');}
            } else {
                if (bottom_of_window < highlightPoints[5]) {$h3s.eq(5).removeClass('highlight');}
                if (bottom_of_window < highlightPoints[4]) {$h3s.eq(4).removeClass('highlight');}
                if (bottom_of_window < highlightPoints[3]) {$h3s.eq(3).removeClass('highlight');}
                if (bottom_of_window < highlightPoints[2]) {$h3s.eq(2).removeClass('highlight');}
                if (bottom_of_window < highlightPoints[1]) {$h3s.eq(1).removeClass('highlight');}
                if (bottom_of_window < highlightPoints[0]) {$h3s.eq(0).removeClass('highlight');}
            }
        }
    });
});



